export default "__VITE_ASSET__D_7M_F5___"